import React, { useEffect, useState } from 'react';

function limpar(t) {
  return (t || '').split('\n').map(function (l) { return l.trim().replace(/^##\s*/, '').replace(/^-\s*/, ''); }).filter(Boolean).join('. ');
}

function pedacos(t) {
  const frases = t.replace(/([.!?:])\s+/g, '$1|').split('|');
  const saida = []; let atual = '';
  frases.forEach(function (f) {
    if ((atual + ' ' + f).length > 220 && atual) { saida.push(atual); atual = f; } else { atual = atual ? atual + ' ' + f : f; }
  });
  if (atual) saida.push(atual);
  return saida;
}

export default function BotaoOuvir({ texto }) {
  const [falando, setFalando] = useState(false);
  const suportado = typeof window !== 'undefined' && 'speechSynthesis' in window;
  useEffect(function () { return function () { try { window.speechSynthesis.cancel(); } catch (e) {} }; }, []);
  if (!suportado) return null;

  function alternar() {
    const s = window.speechSynthesis;
    if (falando) { s.cancel(); setFalando(false); return; }
    s.cancel();
    const vozes = s.getVoices();
    const voz = vozes.find(function (v) { return (v.lang || '').toLowerCase() === 'pt-br'; }) || vozes.find(function (v) { return (v.lang || '').toLowerCase().indexOf('pt') === 0; });
    const lista = pedacos(limpar(texto));
    lista.forEach(function (p, i) {
      const u = new SpeechSynthesisUtterance(p);
      u.lang = 'pt-BR'; u.rate = 0.95;
      if (voz) u.voice = voz;
      if (i === lista.length - 1) { u.onend = function () { setFalando(false); }; }
      s.speak(u);
    });
    setFalando(true);
  }

  return (
    <button type="button" onClick={alternar} className="w-full mb-6 rounded-xl border-2 border-[#E2B84A] text-[#E2B84A] font-bold text-xl py-4 print:hidden">
      {falando ? '⏹ Parar' : '🔊 Ouvir a aula'}
    </button>
  );
}
